const SideBar: React.FC<{}> = ({}) => {
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li className="nav-item">
          <a className="nav-link" href="/">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">States</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/users">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">Users</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/tags">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">Tags</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/app-category">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">App Category</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/notification-workflow-map">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">Notification Workflow Map</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/page-url-category">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">PageURL Category</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/page-url">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">PageURL</span>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default SideBar;
